import React from "react";
import { useState } from "react";
import Logo from "../../media/logonobg.png";
import "./Login.css";
import bienvenue from "../../media/bienvenue.jpg";
import AuthService from "../../HTTP/auth.service";

const ResetPassword = () => {
    // State to track the current step of the process
    const [step, setStep] = useState(1); // 1: Email, 2: Code, 3: New password
    
    // States for user inputs
    const [email, setEmail] = useState("");
    const [verificationCode, setVerificationCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    
    // States for error/success messages
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    
    // Function to handle email submission (step 1)
    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMsg("");
        setSuccessMessage("");
        
        // Simple client-side validation
        if (!email || !email.includes("@")) {
            setErrorMsg("Please enter a valid email address.");
            setLoading(false);
            return;
        }
        
        try {
            // API call to get reset code
            const response = await AuthService.getCodeForResetPassword(email);
            if (response) {
                setSuccessMessage("A verification code has been sent to your email address.");
                setStep(2);
            } else {
                setErrorMsg("Error sending code. Please try again.");
            }
        } catch (err) {
            setErrorMsg(err.message || "An error occurred while sending the code.");
        } finally {
            setLoading(false);
        }
    };
    
    // Function to handle code verification (step 2)
    const handleCodeVerification = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMsg("");
        setSuccessMessage("");
        
        // Simple client-side validation
        if (!verificationCode || verificationCode.length < 4) {
            setErrorMsg("Please enter a valid verification code.");
            setLoading(false);
            return;
        }
        
        try {
            // API call to verify code
            const response = await AuthService.verifyResetCode(email, verificationCode);
            if (response) {
                setSuccessMessage("Code verified successfully.");
                setStep(3);
            } else {
                setErrorMsg("Invalid verification code. Please try again.");
            }
        } catch (err) {
            setErrorMsg(err.message || "Error verifying code.");
        } finally {
            setLoading(false);
        }
    };
    
    // Function to handle password reset (step 3)
    const handlePasswordReset = async (e) => {
        console.log("handlePasswordReset");
        e.preventDefault();
        setLoading(true);
        setErrorMsg("");
        setSuccessMessage("");
        
        // Local password validation
        if (newPassword.length < 6) {
            setErrorMsg("Password must contain at least 6 characters.");
            setLoading(false);
            return;
        }
        
        if (newPassword !== confirmPassword) {
            setErrorMsg("Passwords do not match.");
            setLoading(false);
            return;
        }
        
        try {
            // API call to reset password
            const response = await AuthService.resetPassword(email, verificationCode, newPassword);
            if (response) {
                setSuccessMessage("Your password has been reset successfully. You can now log in.");
                // Redirect to login page after delay
                setTimeout(() => {
                    window.location.href = "/login";
                }, 3000);
            } else {
                setErrorMsg("Error resetting password. Please try again.");
            }
            
        } catch (err) {
            setErrorMsg(err.message || "Error resetting password.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    
    // Function to go back to previous step
    const handleBack = () => {
        setErrorMsg("");
        setSuccessMessage("");
        setStep(step - 1);
    };

    // Render content based on current step
    const renderStepContent = () => {
        switch (step) {
            case 1:
                return (
                    <form onSubmit={handleEmailSubmit}>
                        <img
                            src={Logo}
                            className="logo"
                            style={{ width: "220px", marginTop: "0", maxWidth: "80%", marginBottom: "15px", marginLeft: "0" }}
                            onClick={() => window.location.href = "/"}
                            alt="Logo"
                        />
                        <h1 className="titr">Reset Password</h1>
                        <p>Please enter your email address to receive a verification code.</p>
                        <input 
                            type="email" 
                            placeholder="Email" 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required 
                            />
                        <button type="submit" className="loginButton" style={{ background: "#009AAD", borderColor: "#009AAD" }} disabled={loading}>
                            {loading ? "Sending..." : "Send Code"}
                        </button>
                            { 
                                errorMsg && <div className="divErrMessage"> <p style={{marginTop: 25, fontWeight: 'bold'}}>{errorMsg}</p> </div> 
                            } 
                            { 
                                successMessage && <div className="divSuccessMessage"> <p style= {{color: "rgb(41, 175, 79)", fontSize: 19, marginTop: 25, fontWeight: 'bold'}}>{successMessage}</p> </div> 
                            }
                    </form>
                );
            case 2:
                return (
                    <form onSubmit={handleCodeVerification}>
                        <img
                            src={Logo}
                            className="logo"
                            style={{ width: "220px", marginTop: "0", maxWidth: "80%", marginBottom: "15px", marginLeft: "0" }}
                            onClick={() => window.location.href = "/"}
                            alt="Logo"
                        />
                        { 
                            errorMsg && <div className="divErrMessage"> <p style={{marginTop: 25, fontWeight: 'bold'}}>{errorMsg}</p> </div> 
                        } 
                        { 
                            successMessage && <div className="divSuccessMessage"> <p style= {{color: "rgb(41, 175, 79)", fontSize: 19, marginTop: 25, fontWeight: 'bold'}}>{successMessage}</p> </div> 
                        }
                        <h1 className="titr">Verification</h1>
                        <p>Enter the 6-digit code sent to {email}</p>
                        <input 
                            type="text" 
                            placeholder="Verification Code" 
                            value={verificationCode}
                            onChange={(e) => setVerificationCode(e.target.value)}
                            maxLength={6}
                            required 
                        />
                        <div style={{ display: "flex", width: "68%", justifyContent: "space-between", marginTop: "10px" }}>
                            <button type="button" className="loginButton" onClick={handleBack} style={{ color: "black" }} disabled={loading}>
                                Back
                            </button>
                            <button type="submit" className="loginButton" style={{ background: "#009AAD", borderColor: "#009AAD" }} disabled={loading}>
                                {loading ? "Verifying..." : "Verify"}
                            </button>
                        </div>
                    </form>
                );
            case 3:
                return (
                    <form onSubmit={handlePasswordReset}>
                        <img
                            src={Logo}
                            className="logo"
                            style={{ width: "220px", marginTop: "0", maxWidth: "80%", marginBottom: "15px", marginLeft: "0" }}
                            onClick={() => window.location.href = "/"}
                            alt="Logo"
                        />
                        <h1 className="titr">New Password</h1>
                        <p>Create a new password for your account.</p>
                        <input
                            type="hidden"
                            value={email}
                            />
                        <input 
                            type="password" 
                            placeholder="New Password" 
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required 
                            />
                        <input 
                            type="password" 
                            placeholder="Confirm Password" 
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required 
                            />
                        <div style={{ display: "flex", width: "68%", justifyContent: "space-between", marginTop: "10px" }}>
                            <button type="button" className="loginButton" onClick={handleBack} style={{ color: "black" }} disabled={loading}>
                                Back
                            </button>
                            <button type="submit" className="loginButton" style={{ background: "#009AAD", borderColor: "#009AAD" }} disabled={loading}>
                                {loading ? "Resetting..." : "Reset"}
                            </button>
                        </div>
                        { 
                            errorMsg && <div className="divErrMessage"> <p style={{marginTop: 25, fontWeight: 'bold'}}>{errorMsg}</p> </div> 
                        } 
                        { 
                            successMessage && <div className="divSuccessMessage"> <p style= {{color: "rgb(41, 175, 79)", fontSize: 19, marginTop: 25, fontWeight: 'bold'}}>{successMessage}</p> </div> 
                        }
                    </form>
                );
            default:
                return null;
        }
    };

    return (
        <div className="Bodylogin">
            <div className={`containerLogin right-panel-active`} id="container">
                <div className="form-container sign-up-container">
                    {renderStepContent()}
                </div>
                <div className="overlay-container">
                    <div className="overlay">
                        <div
                        style={ {backgroundImage: `url(${bienvenue})` } }
                        className="overlay-panel overlay-left"
                        >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;